import { gql } from '@apollo/client';

export const GET_CUSTOMER_DATANORM = gql`
    query GetCustomerDatanorm {
        getCustomerDatanorm {
            exists
            fileName
            lastModified
            size
            rebuildRequestAllowed
            rebuildRequestHint
        }
    }
`;
